module.exports = __webpack_public_path__ + "img/retired-certificates.5c2aae2a.jpg";